// extracted by mini-css-extract-plugin
export var btnMargin = "SectionHeader-module--btnMargin--c7145";
export var headingContainer = "SectionHeader-module--headingContainer--5cc2f";
export var headingContentContainer = "SectionHeader-module--headingContentContainer--b883d";
export var sectionHeader = "SectionHeader-module--sectionHeader--96253";